import Vue from 'vue';
import dataApi from '../data/api';
import Bucket from './bucket';

const LIST_BUCKETS_REQUEST = 'LIST_BUCKETS_REQUEST',
    LIST_BUCKETS_SUCCESS = 'LIST_BUCKETS_SUCCESS',
    LIST_BUCKETS_ERROR = 'LIST_BUCKETS_ERROR';


const state = {
    buckets: [],
    listBucketsStatus: {},
};

const getters = {
    buckets: state => state.buckets,
    selectedBucket: state => state.selectedBucket,
    listBucketsStatus: state => state.listBucketsStatus,
};

const actions = {
	[LIST_BUCKETS_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(LIST_BUCKETS_REQUEST);
		dataApi.listBuckets()
			.then(response => {
                let buckets = response.data.map(Bucket.fromDTO);

				commit(LIST_BUCKETS_SUCCESS, buckets);
			})
			.catch(error => {
				commit(LIST_BUCKETS_ERROR);
			});
    },
};

const mutations = {
	[LIST_BUCKETS_REQUEST]: (state) => {
        state.buckets = [];
		state.listBucketsStatus = {
			loading: true
        };
	},
	[LIST_BUCKETS_SUCCESS]: (state, buckets) => {
		state.listBucketsStatus = {
			success: true
        };
        state.buckets = buckets;
	},
	[LIST_BUCKETS_ERROR]: (state) => {
		state.listBucketsStatus = {
			error: true
		};
    }
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/data/store.js